import { LOCALE } from './i18n';
import { DETAILED_ASSET_ALLOCATION } from '../enums/AssetAllocation';
import { ASSET_ALLOCATION_GROUPS } from './constants';
import Fund from '@/types/fund';
import InvestmentItem from '@/types/investment-item';

export const fundToInvestmentItem = (fund: Fund): InvestmentItem => {
  const investmentInfo = fund.fundPortfolio && fund.fundPortfolio.investmentInfo;
  const characteristics = fund.fundPortfolio && fund.fundPortfolio.characteristics;
  const allocations = fund.fundPortfolio && fund.fundPortfolio.allocations;
  const holdings = fund.fundPortfolio && fund.fundPortfolio.holdings;

  return {
    _id: fund._id,
    pbRatio: investmentInfo && investmentInfo.pbRatio,
    peRatio: investmentInfo && investmentInfo.peRatio,
    distributionYield: fund.distributionYield,
    returnOnEquity: characteristics && characteristics.returnOnEquity,
    yieldToMaturity: characteristics && characteristics.yieldToMaturity,
    averageCoupon: characteristics && characteristics.averageCoupon,
    effectiveMaturity: characteristics && characteristics.effectiveMaturity,
    effectiveDuration: investmentInfo && investmentInfo.effectiveDuration,
    modifiedDuration: investmentInfo && investmentInfo.modifiedDuration,
    style: investmentInfo && investmentInfo.style,
    capitalization: investmentInfo && investmentInfo.capitalization,
    creditRatingClass: investmentInfo && investmentInfo.creditRatingClass,
    durationClass: investmentInfo && investmentInfo.durationClass,
    allocations,
    holdings,
    assetType: fund.assetType,
  };
};

export const investmentItemHasEquity = (item: InvestmentItem) =>
  ((item.allocations && item.allocations.asset) || []).some(assetAlloc =>
    (assetAlloc.name[LOCALE.EN_CA] || '').toUpperCase().includes(ASSET_ALLOCATION_GROUPS.EQUITY),
  );

export const investmentItemHasFixedIncome = (item: InvestmentItem) =>
  ((item.allocations && item.allocations.asset) || []).some(assetAlloc =>
    (assetAlloc.name[LOCALE.EN_CA] || '').toUpperCase().includes(DETAILED_ASSET_ALLOCATION.FIXED_INCOME.toUpperCase()),
  );
